import { LeadActivity, LeadActivityType } from "views/leads-id/types";
import { isShowingRescheduleRequestActivity } from "views/leads-id/slices/Details/slices/ActivityLog/components/TimeLine/showing-reschedule-request";

const AI_AGENT_ACTOR_TYPES: string[] = ["ai_leasing_agent", "ai_agent"];
const AI_AGENT_ROLE = "leasing agent";
const BOOM_ACTOR = "Boom";
const INTEGRATION_ACTOR_TYPE = "integration";
const NAMED_ACTOR_TYPES: string[] = ["partner", "lead"];

// Showing bookings name their creator on a "Created by" line instead.
const CREATED_BY_LINE_TYPES: LeadActivityType[] = [
  LeadActivityType.SHOWING_REQUESTED,
  LeadActivityType.SHOWING_SCHEDULED
];

export const isAiAgentActor = (actorType?: string): boolean =>
  Boolean(actorType && AI_AGENT_ACTOR_TYPES.includes(actorType));

const isBoomAuthoredRescheduleActivity = (activity: LeadActivity) =>
  isShowingRescheduleRequestActivity(activity.activity_type) &&
  !NAMED_ACTOR_TYPES.includes(activity.actor_type) &&
  !isAiAgentActor(activity.actor_type);

// Partner API changes name the API key, e.g. "Zapier (API key)".
// A note already shows its source as a badge next to the title.
const isCreditedIntegration = (activity: LeadActivity) =>
  activity.actor_type === INTEGRATION_ACTOR_TYPE &&
  activity.metadata.source_name !== activity.actor_name;

export const getActorAttribution = (activity: LeadActivity): string => {
  if (activity.activity_type === LeadActivityType.AI_CALL_RECEIVED) return "";
  if (activity.activity_type === LeadActivityType.SHOWING_INVITE_SENT)
    return "";
  if (CREATED_BY_LINE_TYPES.includes(activity.activity_type)) return "";

  const isPartner = activity.actor_type === "partner";
  const isAiAgent = isAiAgentActor(activity.actor_type);
  if (isBoomAuthoredRescheduleActivity(activity)) return ` by ${BOOM_ACTOR}`;
  if (!isPartner && !isAiAgent && !isCreditedIntegration(activity)) return "";
  if (!activity.actor_name || activity.title.includes(activity.actor_name))
    return "";

  // Partners can name the agent "Leasing agent"; don't repeat the role after it.
  const agentLabel =
    isAiAgent && !activity.actor_name.toLowerCase().endsWith(AI_AGENT_ROLE)
      ? ` ${AI_AGENT_ROLE}`
      : "";
  return ` by ${activity.actor_name}${agentLabel}`;
};

// Who booked the showing, for booking entries only. Null when the lead booked
// it themselves, e.g. from the listing page.
export const getShowingCreator = (activity: LeadActivity): string | null => {
  if (!CREATED_BY_LINE_TYPES.includes(activity.activity_type)) return null;
  if (isAiAgentActor(activity.actor_type)) return `AI ${AI_AGENT_ROLE}`;
  if (activity.actor_type === "partner" && activity.actor_name)
    return activity.actor_name;
  return null;
};
